import { useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";

type GetMySettingsResult = {
  eventIds: number[];
  dashboard: DashboardEntry[];
}

type DashboardEntry = {
  id: number;
  settings: DashboardSettings;
}

type DashboardSettings = {
  [key: string]: number | string[];
}

type UpdateUserPreferencesFunction = (settings: GetMySettingsResult) => Promise<boolean>;

const useUpdateUserPreferences = (): UpdateUserPreferencesFunction => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const user = useCurrentUser();
  const fetcher = useCentralApi(user);
  const updateUserPreferences: UpdateUserPreferencesFunction = async (settings) => {

    const controller = new AbortController();
    setLoading(true);
    try {
      const resp = await fetcher("/api/v3.0/accounts/my/preferences", {
        signal: controller.signal,
        method: "PUT",
        body: JSON.stringify(settings),
      });

      if (!resp.ok) {
        //Will be done in BFLY-8658 or BFLY-9022
      }

      return resp.ok;
      // Handle success or any additional processing here
    } catch (err) {
      return false;
      //Will be done in BFLY-8658 or BFLY-9022
    } finally {
      setLoading(false);
    }
  };

  return updateUserPreferences;
};

export default useUpdateUserPreferences;